import React from 'react'
import * as Styles from './styles'
import { FormattedMessage, useIntl } from 'react-intl'
import Select from '../SelectLocation'
import { useIntegrations } from '../../contexts/integrations.context'
import LinkLocationModal from '../Modals/LinkLocation'
import ExchangeIcon from '~/components/commons/ExchangeIcon'
import useAxios from 'axios-hooks'
const STATUS = {
  NONE: 'divergence',
  PARTIAL: 'pending',
  FULL: 'pending',
  CONFIRMED: 'linked',
}

export default function IntegrationCard({
  type = 'linked',
  locationId,
  data,
  integrationId,
  linkId,
}) {
  const status = STATUS[type]
  const intl = useIntl()
  const [location, setLocation] = React.useState()
  const { locations, isLoading } = useIntegrations()
  const [{ data: locationAPIDATA }, getLocationData] = useAxios(
    {
      url: `/locations/${encodeURIComponent(locationId)}/integration`,
    },
    {
      manual: true,
      useCache: true,
    }
  )

  React.useEffect(() => {
    if (locationAPIDATA) {
      setLocation({
        value: locationAPIDATA.id,
        label: locationAPIDATA,
      })
    }
  }, [locationAPIDATA])

  React.useEffect(() => {
    if (locationId) {
      getLocationData()
    }
  }, [locationId])

  return (
    <>
      <Styles.Card>
        <Styles.CardHeader>
          <Badge type={status} />
        </Styles.CardHeader>
        <Styles.CardBody>
          <div className="icon--wrapper">
            <div className="icon-container">
              <ExchangeIcon />
            </div>
          </div>
          <div className="left">
            <div className="simple-badge">
              <span>
                <FormattedMessage id={'External data'} />
              </span>
            </div>
            <div>
              <div>
                {data.cnpj && (
                  <div className="cnpj-badge">
                    <span>{data.cnpj}</span>
                  </div>
                )}

                <span className="title">{data.name}</span>
              </div>
              <span className="paragraph">
                {data.address ||
                  intl.formatMessage({ id: 'Street Not Informed' })}
                ,{' '}
                {data.neighborhood ||
                  intl.formatMessage({ id: 'Neighborhood Not Informed' })}{' '}
                - {data.city || intl.formatMessage({ id: 'City Not Informed' })}{' '}
                /{' '}
                {data.state || intl.formatMessage({ id: 'State Not Informed' })}
              </span>
            </div>
          </div>
          <div className="right">
            <div className="simple-badge">
              <span>Google Business Profile:</span>
            </div>
            <Select
              isDisabled={status === 'linked'}
              uniqueKey="location"
              value={location}
              onChange={v => {
                if (v === null) return
                setLocation(v)
              }}
              placeholder={intl.formatMessage({ id: 'Select a location' })}
              options={locations?.map(location => {
                return {
                  value: location.id,
                  label: location,
                }
              })}
              loading={isLoading}
            />
          </div>
        </Styles.CardBody>
        <Styles.CardFooter>
          <LinkLocationModal
            type={status}
            location={location}
            data={data}
            integrationId={integrationId}
            linkId={linkId}
            locationId={locationId}
          />
        </Styles.CardFooter>
      </Styles.Card>
    </>
  )
}

const Badge = ({ type }) => {
  return (
    <Styles.Badge type={type}>
      {(type === 'pending' || type === 'divergence') && (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.99996 18.3332C5.39746 18.3332 1.66663 14.6023 1.66663 9.99984C1.66663 5.39734 5.39746 1.6665 9.99996 1.6665C14.6025 1.6665 18.3333 5.39734 18.3333 9.99984C18.3333 14.6023 14.6025 18.3332 9.99996 18.3332ZM9.16663 12.4998V14.1665H10.8333V12.4998H9.16663ZM9.16663 5.83317V10.8332H10.8333V5.83317H9.16663Z"
              fill="currentColor"
            />
          </svg>
          <span>
            {type === 'pending' ? (
              <FormattedMessage id={`Pending Link`} />
            ) : (
              <FormattedMessage id={`Divergence_one`} />
            )}
          </span>
        </>
      )}
      {type === 'linked' && (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M9.99996 18.3332C5.39746 18.3332 1.66663 14.6023 1.66663 9.99984C1.66663 5.39734 5.39746 1.6665 9.99996 1.6665C14.6025 1.6665 18.3333 5.39734 18.3333 9.99984C18.3333 14.6023 14.6025 18.3332 9.99996 18.3332ZM9.16913 13.3332L15.0608 7.44067L13.8825 6.26234L9.16913 10.9765L6.81163 8.619L5.63329 9.79734L9.16913 13.3332Z"
              fill="currentColor"
            />
          </svg>
          <span>
            {' '}
            <FormattedMessage id={`Linked_one`} />
          </span>
        </>
      )}
    </Styles.Badge>
  )
}
